import { IModal } from 'customTypes';
import { Modal, ModalBackground } from '../../assets/styles/Modal';
import { BtnBlue, BtnGhost, BtnRed } from '../Button';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface Props {
  openModal: any;
  setOpenModal: any;
  options: any;
}

const RadioChkFnModal = ({ openModal, setOpenModal, options }: Props) => {
  const { t } = useTranslation();
  const [radioVal, setRadioVal] = useState<string>(options.find((el: any) => el.chk === 'Y').value);

  const onChangeFn = (e: any) => {
    setRadioVal(e.target.value);
  };

  // 닫기버튼 클릭
  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };

  // 함수 실행
  const onClickFn = () => {
    openModal.api(radioVal);
    onClickClose();
  };

  return (
    <ModalBackground>
      <Modal>
        <div className='modal radio'>
          <div className='inputForm-head'>
            <h5>
              {t(openModal.title)} {t(openModal.typeName)}
            </h5>
          </div>
          <div className='inputForm-body'>
            <div className='modal-content'>
              <div className='radio-wrap'>
                {options.map((el: any) => (
                  <div key={el.id} className='radio-item'>
                    <input type='radio' name='radioGroup' id={el.id} value={el.value} defaultChecked={el.chk === 'Y'} onChange={(e: any) => onChangeFn(e)} />
                    <label htmlFor={el.id}>{t(el.label)}</label>
                  </div>
                ))}
              </div>
            </div>
            <div className='modal-footer flex-end'>
              <BtnGhost onClick={onClickClose}>{t('닫기')}</BtnGhost>
              {openModal.typeName === '삭제' && <BtnRed onClick={onClickFn}>{t(openModal.typeName)}</BtnRed>}
              {openModal.typeName === '저장' && <BtnBlue onClick={onClickFn}>{t(openModal.typeName)}</BtnBlue>}
            </div>
          </div>
        </div>
      </Modal>
    </ModalBackground>
  );
};

export default RadioChkFnModal;
